import FirebaseConfig from "./config";

import * as firebase from "firebase/app";

import "firebase/auth";

class Firebase {
  public auth: firebase.auth.Auth;
  private app: firebase.app.App;

  constructor() {
    this.app = firebase.initializeApp(FirebaseConfig);
    this.auth = this.app.auth();
  }

  public signIn(
    email: string,
    password: string
  ): Promise<firebase.auth.UserCredential> {
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  public signOut(): Promise<void> {
    return this.auth.signOut();
  }
}

export default Firebase;



// WEBPACK FOOTER //
// ./src/Firebase/firebase.ts